function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
// Limitless imports
import Checkbox from "../../../form-elements/check-box/Checkbox";
import ProductCodeAutoComplete from "../../../graphql/product-code-autocomplete/ProductCodeAutoComplete";
import RadioGroup from "@limitless/modern/inputs/common-radio-group/RadioGroup";
import { log as pilog } from "@limitless/common/utils";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import InfoIcon from "@limitless/icons/InfoCircle";
import AiReasoningStarIcon from "../ai-reasoning-star-icon/AiReasoningStarIcon";
const ATTRIBUTE_MAPPING = {
  boolean: Checkbox
};
class ProductCodeSearch extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      attributes: null,
      hasUserSelectedProduct: false
    });
    /**
     * msgClassification
     *    classificationCode
     *    classificationDescription
     *    attributes: []
     */
    _defineProperty(this, "handleProductSelection", product => {
      this.setState({
        hasUserSelectedProduct: true
      });
      const {
        onValueChange,
        action,
        isMandatory
      } = this.props;
      const {
        attributes
      } = this.state;
      let isStepComplete = false;
      if (product && product.value || !isMandatory) {
        isStepComplete = true;
      }
      const attributesToSave = this.getAttributesToSave(attributes);
      const productCode = {
        attributes: attributesToSave,
        classificationCode: product ? product.value : "",
        classificationCodeDescription: product ? product.label : "",
        doLiveUpdate: isStepComplete,
        isStepComplete
      };
      onValueChange({
        [action.payloadKey]: productCode
      });
    });
    _defineProperty(this, "hanldeAttributeChange", (name, index) => {
      const {
        onValueChange,
        action,
        value,
        isMandatory
      } = this.props;
      const {
        attributes
      } = this.state;
      let isStepComplete = false;
      if (value.classificationCode || !isMandatory) {
        isStepComplete = true;
      }
      attributes[index].value = !attributes[index].value;
      const attributesToSave = this.getAttributesToSave(attributes);
      const newValue = {
        ...value,
        attributes: attributesToSave,
        isStepComplete,
        doLiveUpdate: isStepComplete
      };
      onValueChange({
        [action.payloadKey]: newValue
      });
    });
    _defineProperty(this, "getAttributesToSave", uiAttributes => {
      const attributesToSave = [];
      uiAttributes.map(attribute => {
        attributesToSave.push({
          label: attribute.label,
          value: attribute.value,
          name: attribute.name
        });
      });
      return attributesToSave;
    });
  }
  componentDidUpdate(prevProps) {
    var _prevProps$aiReviewDa, _prevProps$aiReviewDa2, _aiReviewData$respond, _aiReviewData$respond2;
    const {
      aiReviewData,
      action,
      onValueChange,
      isMandatory
    } = this.props;
    const prevCode = (_prevProps$aiReviewDa = prevProps.aiReviewData) === null || _prevProps$aiReviewDa === void 0 ? void 0 : (_prevProps$aiReviewDa2 = _prevProps$aiReviewDa.respondClassification) === null || _prevProps$aiReviewDa2 === void 0 ? void 0 : _prevProps$aiReviewDa2.classificationCode;
    const newCode = aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond = aiReviewData.respondClassification) === null || _aiReviewData$respond === void 0 ? void 0 : _aiReviewData$respond.classificationCode;
    const newLabel = aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond2 = aiReviewData.respondClassification) === null || _aiReviewData$respond2 === void 0 ? void 0 : _aiReviewData$respond2.classificationCodeDescription;
    if (newCode && newCode !== prevCode) {
      this.setState({
        hasUserSelectedProduct: false
      });
    }
    const shouldSendAIUpdate = newCode && newCode !== "Uncategorized" && newCode !== prevCode;
    if (shouldSendAIUpdate) {
      const isStepComplete = isMandatory ? !!newCode : true;
      const attributes = this.getAttributesToSave(this.state.attributes || []);
      const productCode = {
        attributes,
        classificationCode: newCode,
        classificationCodeDescription: newLabel,
        doLiveUpdate: true,
        isStepComplete
      };
      onValueChange({
        [action.payloadKey]: productCode
      });
    }
  }
  render() {
    var _aiReviewData$respond3, _aiReviewData$respond4;
    const {
      value,
      isMandatory,
      classes,
      message,
      isReadOnly,
      aiReviewData
    } = this.props;
    const {
      attributes
    } = this.state;
    const {
      msgClassificationMetaData: {
        classificationCode
      }
    } = this.props.message;
    const selectedProduct = {};
    if (this.state.hasUserSelectedProduct && value.classificationCode) {
      selectedProduct.value = value.classificationCode;
      selectedProduct.label = value.classificationCodeDescription;
    } else if (aiReviewData !== null && aiReviewData !== void 0 && (_aiReviewData$respond3 = aiReviewData.respondClassification) !== null && _aiReviewData$respond3 !== void 0 && _aiReviewData$respond3.classificationCode && aiReviewData.respondClassification.classificationCode !== "Uncategorized") {
      selectedProduct.value = aiReviewData.respondClassification.classificationCode;
      selectedProduct.label = aiReviewData.respondClassification.classificationCodeDescription;
    } else if (value.classificationCode) {
      selectedProduct.value = value.classificationCode;
      selectedProduct.label = value.classificationCodeDescription;
    }
    let locale;
    //if the message/group doesn't have a country, "undefined" will be sent and we'll end up with 0 results always
    if (message.country) {
      locale = `${message.language}-${message.country}`.toLowerCase();
    }
    const ATTRIBUTE_OPTIONS = [{
      value: "Known",
      label: "Known"
    }, {
      value: "Unknown",
      label: "Unknown"
    }];
    const aiClassificationReasoning = aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond4 = aiReviewData.respondClassification) === null || _aiReviewData$respond4 === void 0 ? void 0 : _aiReviewData$respond4.reasoning;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProductCodeAutoComplete, {
      label: /*#__PURE__*/React.createElement(React.Fragment, null, classificationCode.label, aiClassificationReasoning && /*#__PURE__*/React.createElement(AiReasoningStarIcon, {
        title: aiReviewData.respondClassification.reasoning
      })),
      placeholder: classificationCode.hint,
      tenant: message.tenantName,
      group: message.groupName,
      locale: locale,
      onChange: this.handleProductSelection,
      selectedProduct: selectedProduct,
      isMandatory: isMandatory,
      disabled: isReadOnly
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.attributeContainer
    }, attributes.map((attribute, index) => {
      const AttributeComponent = ATTRIBUTE_MAPPING[attribute.type];
      //ensure it's a supported type
      if (!AttributeComponent) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.attributeItem
      }, /*#__PURE__*/React.createElement(RadioGroup, {
        id: "attributeCode",
        label: attribute.label,
        value: attribute.value === true ? 0 : 1,
        options: ATTRIBUTE_OPTIONS,
        onClick: name => selectedProduct.value && this.hanldeAttributeChange(name, index),
        disabled: isReadOnly
      }), attribute.hint && /*#__PURE__*/React.createElement(IconButton, {
        icon: /*#__PURE__*/React.createElement(InfoIcon, null),
        label: attribute.hint
      })));
    })));
  }
}
_defineProperty(ProductCodeSearch, "getDerivedStateFromProps", props => {
  var _value$attributes;
  const {
    message,
    value
  } = props;
  if (!(value !== null && value !== void 0 && (_value$attributes = value.attributes) !== null && _value$attributes !== void 0 && _value$attributes.length)) {
    const log = pilog.getLogger("ProductCodeSearch");
    const attributes = [];
    try {
      message.msgClassificationMetaData.attributes.map(attribute => {
        attribute.type = attribute.type || "boolean";
        const value = attribute.type === "boolean" ? false : "";
        const defaultValue = attribute.type === "boolean" ? attribute.default === "true" : attribute.default;
        attribute.value = attribute.default ? defaultValue : value;
        if (attribute.enabled !== false) {
          attributes.push(attribute);
        }
      });
    } catch (error) {
      log.error(`Failed to process msgClassificationMetaData attributes for ${message.messageId}`, error);
    }
    return {
      attributes
    };
  } else {
    const attributesWithMetaData = [];
    value.attributes.map((attribute, index) => {
      const newAttribute = {
        ...message.msgClassificationMetaData.attributes[index],
        ...attribute
      };
      attributesWithMetaData.push(newAttribute);
    });
    return {
      attributes: attributesWithMetaData
    };
  }
});
const styles = theme => ({
  container: {
    display: "table",
    backgroundColor: theme.palette.background.default
  },
  attributeContainer: {
    paddingLeft: 0
  },
  attributeItem: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between"
  }
});
export default withStyles(styles)(ProductCodeSearch);
ProductCodeSearch.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  value: PropTypes.object,
  isMandatory: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  aiReviewData: PropTypes.object,
  isAIDraftSelected: PropTypes.bool
};